import { ERROR_PREFIX as o } from "../../constants/index.js";

const r = (r, ...n) => {
    throw console.warn(...n), new Error(o + r);
};

export { r as default };
//# sourceMappingURL=index.js.map
